import { useEffect, useRef } from 'react';

import useDataTracking from './useDataTracking';

/**
 * Hook to track custom data analytics events
 */
export default function useDataTrackingEffect(...params: Record<string, unknown>[]) {
    const hasTracked = useRef(false);

    const trackEvent = useDataTracking();

    useEffect(() => {
        if (!hasTracked.current) {
            trackEvent(...params);
            hasTracked.current = true;
        }
    }, [trackEvent, params]);
}
